import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./App";
import { TrackingApp } from "./TrackingApp";
import { isPreviewHost, isTrackingHost } from "./environment";
import "./theme-scales.css";
import "./theme.css";
import "./styles.css";

const root = document.getElementById("root");
if (!root) throw new Error("Root element is missing");
const trackingHost = isTrackingHost(location.hostname) || location.hash.startsWith("#t=");
if (isPreviewHost(location.hostname)) document.documentElement.classList.add("preview-environment");
createRoot(root).render(<StrictMode>{trackingHost ? <TrackingApp /> : <App />}</StrictMode>);
